module.exports = __webpack_public_path__ + "img/laptop_d250.35f82098.svg";